export default "__VITE_ASSET__af516fa2__"